import { Area, IViolation } from 'src/app/models';
import { IBomHeader } from 'src/app/state/bom-header/bom-header.model';

export abstract class BomLockedValidation {
  public static validate(bomHeader?: IBomHeader): IViolation[] {
    const isValid = !bomHeader || Number(bomHeader.bomStatus) >= 22;

    if (isValid) {
      return [];
    }

    return [
      {
        message: 'The BOM has not been locked.',
        pathToViolation: [{ area: Area.Materials }, { area: Area.MaterialBom }],
      },
    ];
  }
}
